var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.312,
    height: 12.523,
    viewBox: "0 0 14.312 12.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-application",
    transform: "translate(0.288 1.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M100.708,75.832a.537.537,0,0,0-.538.537v11.45a.537.537,0,0,0,.538.537h13.237a.537.537,0,0,0,.538-.537V76.369a.537.537,0,0,0-.538-.537Zm.538,3.936h12.162v7.514H101.245Zm7.861-1.968a.537.537,0,0,1,.538-.537H110a.537.537,0,1,1,0,1.073h-.358A.537.537,0,0,1,109.106,77.8Zm2.688-.537a.537.537,0,1,0,0,1.073h.358a.537.537,0,1,0,0-1.073Z",
    transform: "translate(-100.458 -77.129)",
    fill: "#7b7b7b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M0,4.548,3.575,1.4,5.368,2.864,7.092,1.42,5.973,1.052,9.429,0,8.044,3.133l-.29-.941L5.377,4.184,3.6,2.732.692,5.295Z",
    transform: "translate(2.153 3.611)",
    fill: "#7b7b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApplication);
export default __webpack_public_path__ + "static/media/icon-application.af4c5f298c7d334405b78f972559c750.svg";
export { ForwardRef as ReactComponent };